import React, { useState, useEffect } from "react";
import { sendData, getData } from "../../services/auth";
import { uriList } from "../../helpers/config";
import { Button } from "reactstrap";
import { width, generateId, posicoes } from "../../helpers";
import InsertContagemItens from "./estoqueItens";


import { confirmSwal, swalError, } from "../../helpers/swal";
import * as moment from "moment";
import { Aguarde, getCookie } from '../../helpers/general'
import { useSelector } from "react-redux";

import { Pagination, InputLabelAlert, DropDownMenu } from '../../common/layout'

const ContagensEstoque = (props) => {
  const [pesquisa, setPesquisa] = useState("");
  const [actualPage, setActualPage] = useState(0);
  const [qtdLinesPage, setQtdLinesPage] = useState(10);
  const [modal, setModal] = useState(false);
  const [editar, setEditar] = useState(null);
  const [carregando, setCarregando] = useState(false);
  const [excluindo, setExcluindo] = useState(false);
  const [Contagens, setContagens] = useState([]);
  const [allDocuments, setAllDocuments] = useState([]);
  const [insertItens, setInsertItens] = useState(false);
  const _login = useSelector((state) => state.login);

  async function _getData(_posicao) {
    setEditar(null)
    setCarregando(true)
    await sendData({ uri: uriList("contagensEstoque"), content: { pessoaid: null } })
      .then((res) => {
        console.log("Contagens._getData: ", res);

        if (res) {
            let _data = res
            setAllDocuments(_data)
            setContagens(_data)
        }
        })
      .catch((e) => {
        console.log(e);
        // alert("Erro ao obter Contagens.\n" + e.message);
      });
    setCarregando(false)
  }

  async function handleCancelar(contagemid) {
    async function callback(e) {
      if (!e) return

      console.log("Contagens.cancelarContagem: ", { contagemid })

      await sendData({ uri: uriList("cancelarContagem"), content: { empresaid: _login.empresaid, usuarioid: _login.usuarioID, contagemid } })
        .then((res) => {
          console.log("Contagens.cancelarContagem: ", res.data);
          if (res.status && parseInt(res.status) > 200) throw new Error();

          _getData()
        })
        .catch((e) => {
          console.log(e);
          // alert("Erro ao obter Contagens.\n" + e.message);
        });
    }

    confirmSwal({ title: "Deseja cancelar a contagem?", callback })
  }

  async function handleNovaContagem(_posicao) {
    async function callback(e) {
      if (!e) return

      await sendData({ uri: uriList("novaContagem"), content: { empresaid: _login.empresaid, usuarioid: _login.usuarioID } })
        .then((res) => {
          console.log("Contagens.novaContagem: ", res.data);
          if (res.status && parseInt(res.status) > 200) throw new Error();

          _getData()
        })
        .catch((e) => {
          console.log(e);
          // alert("Erro ao obter Contagens.\n" + e.message);
        });
    }

    confirmSwal({ title: "Deseja criar uma nova contagem?", callback })
  }

  useEffect(() => {
    _getData(props.posicao);
  }, []);

  useEffect(() => {
    filtrarRegistros()
  }, [pesquisa])

  async function closeModal() {
    handleLimparFiltros()
    setModal(false)
    setEditar(null)
    setInsertItens(null)

    await _getData();
  }

  function handlePage(e) {
    setActualPage(e.currentTarget.value);
  }

  function handleEdit(e) {
    setEditar(e)
    setModal(true);
  }

  function handleInsertItens(e) {
    setInsertItens(e)
    setModal(true);
  }

  function filtrarRegistros() {
    setContagens(allDocuments)
  }

  function handlePesquisa(e) {
    setPesquisa(e.target.value)
  }

  function handleLimparFiltros() {
    setPesquisa("")
  }

  return (
    <div style={{ height: "80vh", overflowY: "auto" }}>
      {modal && insertItens &&
        <InsertContagemItens onCloseEv={closeModal} data={insertItens} />
      }
      <div
        style={{
          flexDirection: width() == "mobile" ? "column" : "",
          alignItems: "center",
          justifyContent: "center",
          padding: "10px",
        }}
      >
        <div className="col-md-12 mb-5">
          <div className={`${width() == "mobile" ? "h3" : "h1"} center-elements`}>Contagens de Estoque</div>
        </div>

        <div className="col-md-12 mb-2">
          <div className={`${width() == "mobile" ? "col-12" : "col-3 p-0"} d-flex align-items-center justify-content-left mb-3`}>
            <button className="btn btn-primary ml-1" onClick={handleNovaContagem} disabled={carregando} style={{ width: width() == "mobile" ? "35px" : "" }}>
              <i className="fa fa-plus-circle"></i>
            </button>
          </div>
          <div className={`p-0 ${width() == "mobile" ? "d-block" : "d-flex"} `}>
            <div className={`${width() == "mobile" ? " col-12" : "col-3 p-0"} `}>
              <InputLabelAlert
                type="text"
                label="Pesquisa"
                id="pesquisa"
                cifrao={false}
                value={pesquisa}
                handle={handlePesquisa}
                focus={true}
              />
            </div>
            <div className={`${width() == "mobile" ? " col-12 mb-2" : "col-2 ml-2 p-0"} `}>
              <div className="mt-3">
                <button className={`${width() == "mobile" ? "" : "ml-1 "} btn btn-secondary `} onClick={handleLimparFiltros} >
                  Limpar Filtros
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-12" style={{ overflowX: "auto", }}>
          {/* <div className="border rounded p-1 mb-1"> */}
          <div>
            <table className="table table-striped table-hover mb-1 rounded " >
              <thead className="thead-dark">
                <tr>
                  <th scope="col" style={{ width: "5%" }}>#</th>
                  {!props.empresa && <th scope="col" style={{ width: "50%" }}>Nome</th>}
                  <th scope="col" >Tipo</th>
                  {width() != "mobile" && <th scope="col" style={{ width: "10%" }}>Data</th>}
                  {/* <th scope="col"></th> */}
                  <th
                    scope="col"
                    style={{ width: "10%" }}
                    className="text-center"
                  >
                    Ações
                  </th>
                </tr>
              </thead>
              <tbody>
                {!Contagens && <tr>Carregando...</tr>}
                {Contagens?.map((contagem, index) => {
                  return (<>
                    {index >= actualPage * qtdLinesPage &&
                      index < (actualPage + 1) * qtdLinesPage &&
                      (

                        <tr style={{
                          cursor: "pointer", textDecoration: ["VENCIDO", "INATIVO", "VENCENDO"].indexOf(contagem.POSICAO) >= 0 ? "line-through" : "",
                          textDecorationStyle: ["VENCIDO", "INATIVO"].indexOf(contagem.POSICAO) >= 0 ? "double" : "",
                          color: ["VENCIDO", "INATIVO"].indexOf(contagem.POSICAO) >= 0 ? "red " : contagem.POSICAO == "VENCENDO" ? "orange" : ""
                        }}
                          onDoubleClick={() => handleEdit(contagem)} >
                          <th scope="row" style={{ maxWidth: "10px", width: "5%" }}>{index + 1}</th>
                          {!props.empresa && contagem?.NOME && <td style={{ maxWidth: "150px", width: "50%" }}>{contagem?.NOME?.substring(0, width() == "mobile" ? 15 : 100)}</td>}
                          <td >{contagem.TIPO}</td>
                          {width() != "mobile" && <td style={{ width: "10%" }}>{moment(contagem.DATA_CADASTRO).format('DD/MM/YYYY')}</td>}
                          <td style={{ width: "10%" }}>
                            <div className="d-flex justify-content-center" style={{ overflow: 'hidden', }}>
                              <DropDownMenu items={[
                                { descricao: "Lançar Produtos", onClick: e => handleInsertItens(contagem), className: "fa fa-edit", title: "Lançar Produtos" },
                                { descricao: "Cancelar", onClick: e => handleCancelar(contagem.CONTAGEMID), className: "fa fa-ban", title: "Cancelar a Contagem de Estoque", color: "orange", separatorTop: true },
                              ]} />
                            </div>
                          </td>
                        </tr>
                      )}
                  </>
                  )
                })
                }
              </tbody>
              <tr>
                <td colSpan="12" className="text-left">
                  Total de Registros: {Contagens && Contagens.length}
                </td>
              </tr>
            </table>
          </div>
          <Pagination
            detailed={Contagens}
            actual={actualPage}
            changePage={handlePage}
            setQtdLinesPage={setQtdLinesPage}
          />
        </div>
      </div>

      {excluindo && <Aguarde />}
    </div>
  );
}

export default ContagensEstoque;

